import { IconName, useNotifications } from "@elearning-platform/ui";
import React, { useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import {
  Container,
  StyledCommonLink,
  IconWrapper,
  DownloadIcon,
  Title,
  Separator,
  TextWrapper,
  Type,
  LoaderIcon,
} from "./multiFilesDownload.styled";
import { downloadFile } from "../../../../api/requests";

export const MultiFilesDownload = ({ className, name, id }) => {
  const { t } = useTranslation();
  const [isDownloadLoading, setIsDownloadLoading] = useState(false);
  const { showPopup, hidePopup } = useNotifications();

  const handleDownload = () => {
    setIsDownloadLoading(true);

    return downloadFile(id)
      .catch((error) => {
        showPopup({
          title: t("competence.app.global.errorOccurred"),
          description: error.message || t("competence.app.global.defaultErrorDescription"),
          acceptButtonData: {
            label: t("competence.app.global.close"),
            onClick: () => hidePopup(),
          },
        });
      })
      .finally(() => {
        setIsDownloadLoading(false);
      });
  };

  return (
    <Container className={className}>
      <StyledCommonLink action={handleDownload}>
        <IconWrapper>
          {isDownloadLoading ? <LoaderIcon name={IconName.Loader} /> : <DownloadIcon />}
        </IconWrapper>
        <TextWrapper>
          <Title>{name}</Title>
          <Type>{t("global.filesToDownload")}</Type>
        </TextWrapper>
      </StyledCommonLink>
      <Separator />
    </Container>
  );
};

MultiFilesDownload.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  url: PropTypes.string,
};
